import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { defaultCatalogLanguage, supportedCatalogLanguages } from './languages'
import footerInfoDe from './locales/de/layout/footerInfo.json'
import headerDe from './locales/de/layout/header.json'
import serviceDetailDe from './locales/de/pages/serviceDetail.json'
import sbiIepDe from './locales/de/pages/sbi/iep.json'
import sbiIndexDe from './locales/de/pages/sbi/index.json'
import sbiSlaDe from './locales/de/pages/sbi/sla.json'
import sbiSupportHoursDe from './locales/de/pages/sbi/supportHours.json'
import catalogCategoriesWorkplaceDe from './locales/de/pages/catalogCategories/workplace.json'
import catalogCategoriesSecurityDe from './locales/de/pages/catalogCategories/security.json'
import catalogCategoriesNetworkCommunicationsDe from './locales/de/pages/catalogCategories/networkCommunications.json'
import catalogCategoriesIntegrationsCloudSolutionsDe from './locales/de/pages/catalogCategories/integrationsCloudSolutions.json'
import catalogCategoriesInfrastructureDe from './locales/de/pages/catalogCategories/infrastructure.json'
import catalogCategoriesCollaborationDe from './locales/de/pages/catalogCategories/collaboration.json'
import businessServicesVerticalSolutionsAfrDe from './locales/de/pages/businessServices/verticalSolutionsAfr.json'
import businessServicesSalesMarketingDe from './locales/de/pages/businessServices/salesMarketing.json'
import businessServicesProcurementDe from './locales/de/pages/businessServices/procurement.json'
import businessServicesManufacturingOperationsDe from './locales/de/pages/businessServices/manufacturingOperations.json'
import businessServicesLogisticsDe from './locales/de/pages/businessServices/logistics.json'
import businessServicesHumanResourcesDe from './locales/de/pages/businessServices/humanResources.json'
import businessServicesHealthAndSafetyDe from './locales/de/pages/businessServices/healthAndSafety.json'
import businessServicesFinanceControllingDe from './locales/de/pages/businessServices/financeControlling.json'
import businessServicesBusinessIntelligenceDe from './locales/de/pages/businessServices/businessIntelligence.json'
import businessServicesDe from './locales/de/pages/businessServices.json'
import homeDe from './locales/de/pages/home.json'
import footerInfoEn from './locales/en/layout/footerInfo.json'
import headerEn from './locales/en/layout/header.json'
import sbiIepEn from './locales/en/pages/sbi/iep.json'
import sbiIndexEn from './locales/en/pages/sbi/index.json'
import sbiSlaEn from './locales/en/pages/sbi/sla.json'
import sbiSupportHoursEn from './locales/en/pages/sbi/supportHours.json'
import catalogCategoriesWorkplaceEn from './locales/en/pages/catalogCategories/workplace.json'
import catalogCategoriesSecurityEn from './locales/en/pages/catalogCategories/security.json'
import catalogCategoriesNetworkCommunicationsEn from './locales/en/pages/catalogCategories/networkCommunications.json'
import catalogCategoriesIntegrationsCloudSolutionsEn from './locales/en/pages/catalogCategories/integrationsCloudSolutions.json'
import catalogCategoriesInfrastructureEn from './locales/en/pages/catalogCategories/infrastructure.json'
import catalogCategoriesCollaborationEn from './locales/en/pages/catalogCategories/collaboration.json'
import businessServicesVerticalSolutionsAfrEn from './locales/en/pages/businessServices/verticalSolutionsAfr.json'
import businessServicesSalesMarketingEn from './locales/en/pages/businessServices/salesMarketing.json'
import businessServicesProcurementEn from './locales/en/pages/businessServices/procurement.json'
import businessServicesManufacturingOperationsEn from './locales/en/pages/businessServices/manufacturingOperations.json'
import businessServicesLogisticsEn from './locales/en/pages/businessServices/logistics.json'
import businessServicesHumanResourcesEn from './locales/en/pages/businessServices/humanResources.json'
import businessServicesHealthAndSafetyEn from './locales/en/pages/businessServices/healthAndSafety.json'
import businessServicesFinanceControllingEn from './locales/en/pages/businessServices/financeControlling.json'
import businessServicesBusinessIntelligenceEn from './locales/en/pages/businessServices/businessIntelligence.json'
import businessServicesEn from './locales/en/pages/businessServices.json'
import homeEn from './locales/en/pages/home.json'
import serviceDetailEn from './locales/en/pages/serviceDetail.json'
import footerInfoFr from './locales/fr/layout/footerInfo.json'
import headerFr from './locales/fr/layout/header.json'
import serviceDetailFr from './locales/fr/pages/serviceDetail.json'
import sbiIepFr from './locales/fr/pages/sbi/iep.json'
import sbiIndexFr from './locales/fr/pages/sbi/index.json'
import sbiSlaFr from './locales/fr/pages/sbi/sla.json'
import sbiSupportHoursFr from './locales/fr/pages/sbi/supportHours.json'
import catalogCategoriesWorkplaceFr from './locales/fr/pages/catalogCategories/workplace.json'
import catalogCategoriesSecurityFr from './locales/fr/pages/catalogCategories/security.json'
import catalogCategoriesNetworkCommunicationsFr from './locales/fr/pages/catalogCategories/networkCommunications.json'
import catalogCategoriesIntegrationsCloudSolutionsFr from './locales/fr/pages/catalogCategories/integrationsCloudSolutions.json'
import catalogCategoriesInfrastructureFr from './locales/fr/pages/catalogCategories/infrastructure.json'
import catalogCategoriesCollaborationFr from './locales/fr/pages/catalogCategories/collaboration.json'
import businessServicesVerticalSolutionsAfrFr from './locales/fr/pages/businessServices/verticalSolutionsAfr.json'
import businessServicesSalesMarketingFr from './locales/fr/pages/businessServices/salesMarketing.json'
import businessServicesProcurementFr from './locales/fr/pages/businessServices/procurement.json'
import businessServicesManufacturingOperationsFr from './locales/fr/pages/businessServices/manufacturingOperations.json'
import businessServicesLogisticsFr from './locales/fr/pages/businessServices/logistics.json'
import businessServicesHumanResourcesFr from './locales/fr/pages/businessServices/humanResources.json'
import businessServicesHealthAndSafetyFr from './locales/fr/pages/businessServices/healthAndSafety.json'
import businessServicesFinanceControllingFr from './locales/fr/pages/businessServices/financeControlling.json'
import businessServicesBusinessIntelligenceFr from './locales/fr/pages/businessServices/businessIntelligence.json'
import businessServicesFr from './locales/fr/pages/businessServices.json'
import homeFr from './locales/fr/pages/home.json'

const resources = {
  en: {
    'layout/footerInfo': footerInfoEn,
    'layout/header': headerEn,
    'pages/serviceDetail': serviceDetailEn,
    'pages/sbi/iep': sbiIepEn,
    'pages/sbi/index': sbiIndexEn,
    'pages/sbi/sla': sbiSlaEn,
    'pages/sbi/supportHours': sbiSupportHoursEn,
    'pages/catalogCategories/workplace': catalogCategoriesWorkplaceEn,
    'pages/catalogCategories/security': catalogCategoriesSecurityEn,
    'pages/catalogCategories/networkCommunications': catalogCategoriesNetworkCommunicationsEn,
    'pages/catalogCategories/integrationsCloudSolutions':
      catalogCategoriesIntegrationsCloudSolutionsEn,
    'pages/catalogCategories/infrastructure': catalogCategoriesInfrastructureEn,
    'pages/catalogCategories/collaboration': catalogCategoriesCollaborationEn,
    'pages/businessServices/verticalSolutionsAfr': businessServicesVerticalSolutionsAfrEn,
    'pages/businessServices/salesMarketing': businessServicesSalesMarketingEn,
    'pages/businessServices/procurement': businessServicesProcurementEn,
    'pages/businessServices/manufacturingOperations': businessServicesManufacturingOperationsEn,
    'pages/businessServices/logistics': businessServicesLogisticsEn,
    'pages/businessServices/humanResources': businessServicesHumanResourcesEn,
    'pages/businessServices/healthAndSafety': businessServicesHealthAndSafetyEn,
    'pages/businessServices/financeControlling': businessServicesFinanceControllingEn,
    'pages/businessServices/businessIntelligence': businessServicesBusinessIntelligenceEn,
    'pages/businessServices': businessServicesEn,
    'pages/home': homeEn,
  },
  fr: {
    'layout/footerInfo': footerInfoFr,
    'layout/header': headerFr,
    'pages/serviceDetail': serviceDetailFr,
    'pages/sbi/iep': sbiIepFr,
    'pages/sbi/index': sbiIndexFr,
    'pages/sbi/sla': sbiSlaFr,
    'pages/sbi/supportHours': sbiSupportHoursFr,
    'pages/catalogCategories/workplace': catalogCategoriesWorkplaceFr,
    'pages/catalogCategories/security': catalogCategoriesSecurityFr,
    'pages/catalogCategories/networkCommunications': catalogCategoriesNetworkCommunicationsFr,
    'pages/catalogCategories/integrationsCloudSolutions':
      catalogCategoriesIntegrationsCloudSolutionsFr,
    'pages/catalogCategories/infrastructure': catalogCategoriesInfrastructureFr,
    'pages/catalogCategories/collaboration': catalogCategoriesCollaborationFr,
    'pages/businessServices/verticalSolutionsAfr': businessServicesVerticalSolutionsAfrFr,
    'pages/businessServices/salesMarketing': businessServicesSalesMarketingFr,
    'pages/businessServices/procurement': businessServicesProcurementFr,
    'pages/businessServices/manufacturingOperations': businessServicesManufacturingOperationsFr,
    'pages/businessServices/logistics': businessServicesLogisticsFr,
    'pages/businessServices/humanResources': businessServicesHumanResourcesFr,
    'pages/businessServices/healthAndSafety': businessServicesHealthAndSafetyFr,
    'pages/businessServices/financeControlling': businessServicesFinanceControllingFr,
    'pages/businessServices/businessIntelligence': businessServicesBusinessIntelligenceFr,
    'pages/businessServices': businessServicesFr,
    'pages/home': homeFr,
  },
  de: {
    'layout/footerInfo': footerInfoDe,
    'layout/header': headerDe,
    'pages/serviceDetail': serviceDetailDe,
    'pages/sbi/iep': sbiIepDe,
    'pages/sbi/index': sbiIndexDe,
    'pages/sbi/sla': sbiSlaDe,
    'pages/sbi/supportHours': sbiSupportHoursDe,
    'pages/catalogCategories/workplace': catalogCategoriesWorkplaceDe,
    'pages/catalogCategories/security': catalogCategoriesSecurityDe,
    'pages/catalogCategories/networkCommunications': catalogCategoriesNetworkCommunicationsDe,
    'pages/catalogCategories/integrationsCloudSolutions':
      catalogCategoriesIntegrationsCloudSolutionsDe,
    'pages/catalogCategories/infrastructure': catalogCategoriesInfrastructureDe,
    'pages/catalogCategories/collaboration': catalogCategoriesCollaborationDe,
    'pages/businessServices/verticalSolutionsAfr': businessServicesVerticalSolutionsAfrDe,
    'pages/businessServices/salesMarketing': businessServicesSalesMarketingDe,
    'pages/businessServices/procurement': businessServicesProcurementDe,
    'pages/businessServices/manufacturingOperations': businessServicesManufacturingOperationsDe,
    'pages/businessServices/logistics': businessServicesLogisticsDe,
    'pages/businessServices/humanResources': businessServicesHumanResourcesDe,
    'pages/businessServices/healthAndSafety': businessServicesHealthAndSafetyDe,
    'pages/businessServices/financeControlling': businessServicesFinanceControllingDe,
    'pages/businessServices/businessIntelligence': businessServicesBusinessIntelligenceDe,
    'pages/businessServices': businessServicesDe,
    'pages/home': homeDe,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: defaultCatalogLanguage,
  fallbackLng: defaultCatalogLanguage,
  supportedLngs: supportedCatalogLanguages,
  ns: [
    'layout/footerInfo',
    'layout/header',
    'pages/home',
    'pages/serviceDetail',
    'pages/businessServices',
    'pages/businessServices/financeControlling',
    'pages/businessServices/healthAndSafety',
    'pages/businessServices/humanResources',
    'pages/businessServices/logistics',
    'pages/businessServices/manufacturingOperations',
    'pages/businessServices/procurement',
    'pages/businessServices/businessIntelligence',
    'pages/businessServices/salesMarketing',
    'pages/businessServices/verticalSolutionsAfr',
    'pages/catalogCategories/collaboration',
    'pages/catalogCategories/infrastructure',
    'pages/catalogCategories/networkCommunications',
    'pages/catalogCategories/workplace',
    'pages/catalogCategories/security',
    'pages/catalogCategories/integrationsCloudSolutions',
    'pages/sbi/index',
    'pages/sbi/sla',
    'pages/sbi/iep',
    'pages/sbi/supportHours',
  ],
  defaultNS: 'pages/home',
  interpolation: {
    escapeValue: false,
  },
  returnEmptyString: false,
})

export default i18n
